export default {
    BACKGROUND_REMOVAL: 'BACKGROUND_REMOVAL',
    AUTO_SUBTITLE:'AUTO_SUBTITLE'
};
